import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../scss/dashboard.scss';
import Header from '../components/header';
import axios from 'axios';
import BaseURL from '../assets/contants/BaseURL';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Chart from 'react-apexcharts';
import moment from 'moment';
import ExcelJS from 'exceljs';

const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const LevelTank = ({ level = 0, maxLevel = 100 }) => {
    const tankPercentage = Math.max(0, Math.min(100, (level / maxLevel) * 100));
    const levelHeight = `${tankPercentage}%`;

    return (
        <div style={{ position: 'relative', width: '200px', height: '280px', margin: 'auto' }}>
            {/* Digital Display */}
            <div style={{
                position: 'absolute',
                top: -5,
                left: 5,
                width: '120px',
                height: '70px',
                backgroundColor: '#ccc',
                border: '2px solid #888',
                borderRadius: '6px',
                padding: '6px',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    backgroundColor: 'black',
                    color: 'red',
                    fontSize: '20px',
                    textAlign: 'center',
                    padding: '4px',
                    borderRadius: '4px'
                }}>
                    {level.toFixed(1)}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                    <button style={{ fontSize: '6px' }}>▲</button>
                    <button style={{ fontSize: '6px' }}>▼</button>
                    <button style={{ fontSize: '6px' }}>ESC</button>
                    <button style={{ fontSize: '6px' }}>ENT</button>
                </div>
            </div>

            {/* Wire to Sensor */}
            <div style={{
                position: 'absolute',
                top: 65,
                left: 50,
                width: '4px',
                height: '28px',
                backgroundColor: '#333'
            }} />
            <div style={{
                position: 'absolute',
                top: 90,
                left: 50,
                width: '50px',
                height: '4px',
                backgroundColor: '#333'
            }} />

            {/* Tank body */}
            <div style={{
                position: 'absolute',
                bottom: '-50px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '130px',
                height: '200px',
                border: '4px solid #888',
                borderRadius: '15px',
                backgroundColor: '#fff',
                overflow: 'hidden'
            }}>
                {/* Water level */}
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    height: levelHeight,
                    backgroundColor: '#69b3f9',
                    transition: 'height 1s ease-in-out'
                }}></div>
            </div>

            {/* Sensor on top of tank */}
            <div style={{
                position: 'absolute',
                top: 90,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '30px',
                height: '35px',
                backgroundColor: '#ccc',
                border: '2px solid #555'
            }} />
            <div style={{
                position: 'absolute',
                top: 75,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '30px',
                height: '15px',
                backgroundColor: 'darkgreen',
                border: '2px solid #333'
            }} />
            <div style={{
                position: 'absolute',
                top: 125,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '8px',
                height: '45px',
                backgroundColor: '#bbb'
            }} />
        </div>
    );
};


const Levelsub = () => {
    const location = useLocation();
    const { meterId } = location.state || {};
    const navigate = useNavigate();
    const [groups, setGroups] = useState([]);
    const [flowData, setFlowData] = useState([]);
    const [dateselectedDate, setdateSelectedDate] = useState(new Date());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedNewYear, setSelectedNewYear] = useState(new Date().getFullYear());
    const [waterLevelData, setWaterLevelData] = useState(null);
    const [waterData, setWaterData] = useState(null);
    const [monthsData, setMonthsData] = useState({
        categories: monthNames,
        levels: Array(12).fill(0),
        graphTitle: "Monthly Water Level",
        xAxisLabel: "Months",
        yAxisLabel: "Level (meters)",
        monthlyStats: {
            averageLevel: 0,
            monthsWithData: 0
        }
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const handleNewDateChange = (date) => {
        setdateSelectedDate(date);
    };

    const handleMonthChange = (e) => setSelectedMonth(parseInt(e.target.value));
    const handleYearChange = (e) => setSelectedYear(parseInt(e.target.value));
    const handleNewYearChange = (e) => {
        const year = parseInt(e.target.value);
        setSelectedNewYear(year);
    };

    const [chartData, setChartData] = useState({
        selected_day: "",
        graph_title: "Hourly Water Level",
        x_axis_label: "Hours",
        y_axis_label: "Level (meters)",
        bars: [
            {
                name: "level",
                data: Array(24).fill(0),
            },
        ],
        time_intervals: Array.from({ length: 24 }, (_, i) =>
            `${i.toString().padStart(2, '0')}:00 to ${((i + 1) % 24).toString().padStart(2, '0')}:00`
        ),
    });

    const [dailyData, setDailyData] = useState({
        categories: [],
        levels: [],
        graphTitle: "Daily Water Level",
        xAxisLabel: "Day of Month",
        yAxisLabel: "Level (meters)",
        monthlyStats: {
            averageLevel: 0,
            daysWithData: 0
        }
    });

    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await axios.get(`${BaseURL}meters/flowgroups/`);
                setGroups(response.data);
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        };
        fetchGroups();
    }, []);

    useEffect(() => {
        const fetchFlowData = async () => {
            if (groups.length === 0) return;

            const today = new Date();
            const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
            const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;

            try {
                const response = await axios.post(`${BaseURL}data/flow-group-table/`, {
                    date: formattedDate,
                });
                setFlowData(response.data?.groups || []);
            } catch (error) {
                console.error("Error fetching flow data:", error);
            }
        };

        fetchFlowData();
    }, [groups]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentGroups = groups.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(groups.length / itemsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalFlow = flowData.reduce((sum, group) => sum + (group.total_liters || 0), 0);

    const handleMeterClick = (group_name) => {
        navigate("/EMS/FlowSubGroup", { state: { group_name } });
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        fetchWaterLevelData();
    }, []);

    const fetchWaterLevelData = async () => {
        const today = new Date();
        const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;

        try {
            const response = await axios.post(`${BaseURL}data/level-summary/`, {
                date: formattedDate,
                meter_id: meterId
            });

            setWaterLevelData(response.data);
        } catch (err) {
            console.error("Error fetching water level data:", err);
        }
    };

    useEffect(() => {
        fetchWaterData();
    }, []);

    const fetchWaterData = async () => {
        const today = new Date();
        const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;
        try {
            const response = await axios.post(`${BaseURL}data/water-level/`, {
                date: formattedDate,
                meter_id: meterId
            });
            setWaterData(response.data);
            console.log(response.data)
        } catch (err) {
            console.error("Error fetching water level data:", err);
        }
    };

    const getStatusColor = (status) => {
        return status === 1 ? 'green' : 'red';
    };

    const getStatusText = (status) => {
        return status === 1 ? 'Active' : 'Inactive';
    };

    useEffect(() => {
        if (meterId && dateselectedDate) {
            fetchHourlyLevelData(dateselectedDate, meterId);
        }
    }, [meterId, dateselectedDate]);

    const fetchHourlyLevelData = async (date, meterId) => {
        try {
            const formattedDate = date.toISOString().split('T')[0];
            const response = await axios.post(`${BaseURL}data/level-hourly-consumption/`, {
                meter_id: meterId,
                date: formattedDate
            });

            if (response.data) {
                setChartData(prev => ({
                    ...prev,
                    selected_day: response.data.selected_day || formattedDate,
                    graph_title: response.data.graph_title || "Hourly Water Level",
                    x_axis_label: response.data.x_axis_label || "Hours",
                    y_axis_label: response.data.y_axis_label || "Level (meters)",
                    bars: response.data.bars || [{ name: "level", data: Array(24).fill(0) }],
                    time_intervals: response.data.time_intervals ||
                        Array.from({ length: 24 }, (_, i) =>
                            `${i.toString().padStart(2, '0')}:00 to ${((i + 1) % 24).toString().padStart(2, '0')}:00`
                        )
                }));
            }
        } catch (error) {
            console.error("Error fetching hourly level data:", error);
        }
    };

    useEffect(() => {
        if (meterId) {
            fetchDailyLevelData(meterId, selectedMonth, selectedYear);
        }
    }, [meterId, selectedMonth, selectedYear]);

    const fetchDailyLevelData = async (meterId, month, year) => {
        try {
            const response = await axios.post(`${BaseURL}data/level-daily-consumption/`, {
                meter_id: meterId,
                month: month,
                year: year
            });

            if (response.data) {
                const dailyData = response.data.data.daily;
                const dates = Object.keys(dailyData).sort((a, b) => new Date(a) - new Date(b));
                const levels = dates.map(date => dailyData[date][0]);

                setDailyData({
                    categories: dates,
                    levels: levels,
                    graphTitle: response.data.graph_title || `Daily Water Level for ${monthNames[month - 1]} ${year}`,
                    xAxisLabel: response.data.x_axis_label || "Day of Month",
                    yAxisLabel: response.data.y_axis_label || "Level (meters)",
                    monthlyStats: {
                        averageLevel: response.data.data.monthly.average_level || 0,
                        daysWithData: response.data.data.monthly.days_with_data || 0
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching daily level data:", error);
        }
    };

    useEffect(() => {
        if (meterId) {
            fetchMonthlyLevelData(meterId, selectedNewYear);
        }
    }, [meterId, selectedNewYear]);

    const fetchMonthlyLevelData = async (meterId, year) => {
        try {
            const response = await axios.post(`${BaseURL}data/level-monthly-consumption/`, {
                meter_id: meterId,
                year: year
            });

            if (response.data) {
                setMonthsData({
                    categories: monthNames,
                    levels: response.data.bars[0].data || Array(12).fill(0),
                    graphTitle: response.data.graph_title || `Monthly Water Level - ${year}`,
                    xAxisLabel: response.data.x_axis_label || "Months",
                    yAxisLabel: response.data.y_axis_label || "Level (meters)",
                    monthlyStats: {
                        averageLevel: response.data.monthly_averages?.average_level || 0,
                        monthsWithData: response.data.monthly_averages?.months_with_data || 0
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching monthly level data:", error);
        }
    };

    const renderMeterDetails = () => {
        if (!waterData?.meter_details) return null;

        const { meter_details, latest_hourly_reading } = waterData;

        return (
            <>
                {[
                    [
                        { label: 'Level Sensor Name', value: meter_details.meter_name || 'N/A' },
                        { label: 'Level Sensor ID', value: meter_details.meter_id || 'N/A' },
                    ],
                    [
                        {
                            label: 'Status',
                            value: (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div style={{
                                        width: '80px',
                                        height: '20px',
                                        backgroundColor: getStatusColor(meter_details.status),
                                        borderRadius: '4px',
                                        marginBottom: '5px',
                                    }} />
                                    <span>{getStatusText(meter_details.status)}</span>
                                </div>
                            ),
                        },
                        { label: 'Serial Number', value: meter_details.serial_number || 'N/A' },
                    ],
                    [
                        { label: 'Model', value: meter_details.model || 'N/A' },
                        { label: 'Location', value: meter_details.location || 'N/A' },
                    ],
                    [
                        { label: 'Last Updated', value: latest_hourly_reading?.timestamp || 'N/A' },
                        { label: 'Current Hour', value: latest_hourly_reading?.hour !== undefined ? `${latest_hourly_reading.hour}:00` : 'N/A' },
                    ],
                ].map((row, rowIndex) => (
                    <tr key={rowIndex} style={{ borderBottom: '1px solid #ddd' }}>
                        {row.map((item, cellIndex) => (
                            <td key={`${rowIndex}-${cellIndex}`} style={{
                                padding: '15px',
                                width: '50%',
                                backgroundColor: rowIndex % 2 === 0 ? '#f9f9f9' : '#fff',
                                textAlign: 'center',
                                verticalAlign: 'top',
                                transition: 'background-color 0.3s ease',
                            }}
                                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0f8ff')}
                                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = rowIndex % 2 === 0 ? '#f9f9f9' : '#fff')}
                            >
                                <div style={{ fontWeight: 'bold', marginBottom: '5px', fontSize: '14px', color: '#333' }}>
                                    {item.label}
                                </div>
                                <div style={{ color: '#555', fontSize: '13px', wordWrap: 'break-word' }}>
                                    {item.value}
                                </div>
                            </td>
                        ))}
                    </tr>
                ))}
            </>
        );
    };

    const [activeTab, setActiveTab] = useState("Hourly");
    const [hourlyloading, setHourlyLoading] = useState(false);
    const [hourlyfromdate, setHourlyfromdate] = useState(0);
    const [hourlytodate, setHourlytodate] = useState(0);
    const [hourlyData, setHourlyData] = useState([]);
    const [currenthourlyPage, setCurrenthourlyPage] = useState(1);
    const [totalWaterlevel, setTotalWaterLevel] = useState(0);
    const [dailyloading, setDailyLoading] = useState(false);
    const [dailyreportData, setDailyreportData] = useState([]);
    const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
    const [totalDailyLiters, setTotalDailyLiters] = useState(0);
    const [monthlyloading, setMonthlyLoading] = useState(false);
    const [monthlyfromDate, setmonthlyFromDate] = useState(null);
    const [monthlytoDate, setmonthlyToDate] = useState(null);
    const [currentmonthlyreportPage, setCurrentmonthlyreportPage] = useState(1);
    const [monthData, setMonthData] = useState([]);
    const [reportData, setReportData] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    const tabs = ["Hourly", "Daily", "Monthly"];

    const handleTabChange = (tab) => {
        setActiveTab(tab);

        if (tab !== "Hourly") {
            setHourlyData([]);
            setHourlyfromdate(0);
            setHourlytodate(0);
            setCurrenthourlyPage(1);
            setTotalWaterLevel(0);
        }
        if (tab !== "Daily") {
            setDailyreportData([]);
            setFromDate(0);
            setToDate(0);
            setCurrentdailyreportPage(1);
            setTotalDailyLiters(0);
        }
        if (tab !== "Monthly") {
            setMonthData([]);
            setmonthlyFromDate(0);
            setmonthlyToDate(0);
            setCurrentmonthlyreportPage(1);
            setReportData(0);
        }
    };


    const handleGetHourlyReport = async () => {
        if (!hourlyfromdate || !hourlytodate || !meterId) {
            alert("Please select both date range and ensure meter ID is available");
            return;
        }

        setHourlyLoading(true);
        try {
            const fromDate = moment(hourlyfromdate).format("YYYY-MM-DD");
            const fromTime = moment(hourlyfromdate).format("HH:mm");
            const toDate = moment(hourlytodate).format("YYYY-MM-DD");
            const toTime = moment(hourlytodate).format("HH:mm");

            const response = await axios.post(`${BaseURL}data/level-hourly-report/`, {
                from_date: fromDate,
                to_date: toDate,
                from_time: fromTime,
                to_time: toTime,
                level_meter_id: meterId
            });

            if (response.data.results) {
                const transformedData = response.data.results.time_intervals.map((time, index) => ({
                    id: index,
                    date: response.data.results.date[index],
                    timeInterval: time,
                    waterLevel: response.data.results.columns[0].data[index]
                }));

                setHourlyData(transformedData);
                setTotalWaterLevel(response.data.results.total_water_level);
                
            } else if (response.data.error) {
                alert(response.data.error);
                setHourlyData([]);
                setTotalWaterLevel(0);
            }
        } catch (error) {
            console.error("Error fetching hourly report:", error);
            alert("Failed to fetch hourly report data");
            setHourlyData([]);
            setTotalWaterLevel(0);
        } finally {
            setHourlyLoading(false);
        }
    };
    
        const formatDateForDisplay = (dateString) => {
            return moment(dateString).format("YYYY-MM-DD");
        };
    
        const rowsPerPage = 10;
    
        const totalhourlyPages = Math.ceil(hourlyData.length / rowsPerPage);
    
        const indexOfLastRow = currenthourlyPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentRows = hourlyData.slice(indexOfFirstRow, indexOfLastRow);
    
        const handlehourlyPageChange = (newPage) => {
            setCurrenthourlyPage(newPage);
        };
    
        const handleGetDailyReport = async () => {
            if (!fromDate || !toDate || !meterId) {
                alert("Please select both date range and ensure meter ID is available");
                return;
            }

            setDailyLoading(true);
            try {
                const startDate = moment(fromDate).format("YYYY-MM-DD");
                const startTime = moment(fromDate).format("HH:mm");
                const endDate = moment(toDate).format("YYYY-MM-DD");
                const endTime = moment(toDate).format("HH:mm");

                const response = await axios.post(`${BaseURL}data/level-daily-report/`, {
                    from_date: startDate,
                    to_date: endDate,
                    from_time: startTime,
                    to_time: endTime,
                    level_meter_id: meterId
                });

                if (response.data.results) {
                    const { columns, time_intervals, total_water_level } = response.data.results;
                    
                    const transformedData = time_intervals.map((timeRange, index) => ({
                        id: index,
                        date: timeRange.split(' ')[0],
                        timeRange: timeRange.includes('(No Data)') ? '00:00 to 23:59' : timeRange.split(' ').slice(1).join(' '),
                        waterLevel: columns[0].data[index] || 0
                    }));

                    setDailyreportData(transformedData);
                    setTotalDailyLiters(total_water_level);
                } else if (response.data.error) {
                    alert(response.data.error);
                    setDailyreportData([]);
                    setTotalDailyLiters(0);
                }
            } catch (error) {
                console.error("Error fetching daily report:", error);
                alert("Failed to fetch daily report data");
                setDailyreportData([]);
            } finally {
                setDailyLoading(false);
            }
        };
    
        const rowsdailyPerPage = 10;
        const totaldailyPages = Math.ceil(dailyreportData.length / rowsdailyPerPage);
        const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
        const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
        const currentDailyRows = dailyreportData.slice(indexOfdailyFirstRow, indexOfdailyLastRow);
    
        const handledailyPageChange = (newPage) => {
            setCurrentdailyreportPage(newPage);
        };
    
        const fetchMonthlyReport = async () => {
            if (!monthlyfromDate || !monthlytoDate || !meterId) {
                alert("Please select both date range and ensure meter ID is available");
                return;
            }
    
            setMonthlyLoading(true);
            try {
                const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
                const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;
    
                const response = await axios.post(`${BaseURL}data/level-monthly-report/`, {
                    from_month_year: fromMonthYear,
                    to_month_year: toMonthYear,
                    water_level_id: meterId
                });
    
                setReportData(response.data);
    
                const transformedData = response.data.months.map((month, index) => ({
                    id: index + 1,
                    month: month,
                    totalLevel: response.data.columns[0].data[index]
                }));
                
                setMonthData(transformedData);
            } catch (error) {
                console.error("Error fetching monthly report:", error);
                alert("Failed to fetch monthly report data");
            } finally {
                setMonthlyLoading(false);
            }
        };
    
        const rowsmonthlyPerPage = 10;
        const totalmonthlyPages = Math.ceil(monthData.length / rowsmonthlyPerPage);
        const indexOfmonthlyLastRow = currentmonthlyreportPage * rowsmonthlyPerPage;
        const indexOfmonthlyFirstRow = indexOfmonthlyLastRow - rowsmonthlyPerPage;
        const currentMonthlyRows = monthData.slice(indexOfmonthlyFirstRow, indexOfmonthlyLastRow);
    
        const handlemonthlyPageChange = (newPage) => {
            setCurrentmonthlyreportPage(newPage);
        };
    
        const handleMonthlyFromMonthChange = (date) => {
            setmonthlyFromDate(date);
        };
    
        const handleMonthlyToMonthChange = (date) => {
            setmonthlyToDate(date);
        };
    
        const handleHourlyExportToExcel = async () => {
            const fromDateTime = new Date(hourlyfromdate);
            const toDateTime = new Date(hourlytodate);
    
            const formattedFromDate = fromDateTime.toISOString().split('T')[0];
            const formattedFromTime = fromDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');
            const formattedToDate = toDateTime.toISOString().split('T')[0];
            const formattedToTime = toDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');
    
            const fileName = `Hourly_Level_Report_${formattedFromDate}_${formattedFromTime}_to_${formattedToDate}_${formattedToTime}.xlsx`;
            
            if (!hourlyData || hourlyData.length === 0) {
                alert("No data available to export.");
                return;
            }
    
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Hourly Level Report');
    
            for (let rowNum = 1; rowNum <= 3; rowNum++) {
                const row = worksheet.getRow(rowNum);
                for (let i = 1; i <= 3; i++) {
                    row.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFDDDDDD' },
                    };
                }
            }
    
            try {
                const logoBase64 = await getBase64FromImageUrl('/brad.png');
                const logoId = workbook.addImage({
                    base64: logoBase64,
                    extension: 'png'
                });
    
                const centerCol = Math.floor(3 / 2) - 1;
                worksheet.addImage(logoId, {
                    tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                    br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                    editAs: 'oneCell'
                });
    
                worksheet.getRow(1).height = 30;
                worksheet.getRow(2).height = 30;
                worksheet.getRow(3).height = 30;
            } catch (error) {
                console.error('Error adding logo:', error);
            }
    
            const dateRow = worksheet.addRow([`From: ${moment(hourlyfromdate).format("YYYY-MM-DD HH:mm")} To: ${moment(hourlytodate).format("YYYY-MM-DD HH:mm")}`]);
            worksheet.mergeCells(dateRow.number, 1, dateRow.number, 3);
            dateRow.font = { bold: true, size: 14 };
            dateRow.alignment = { horizontal: 'center' };
            dateRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFD9EAD3' },
                };
            });
    
            const meterInfoRow = worksheet.addRow([
                `Level Meter ID: ${meterId}`,
                '',
                `Site: Coimbatore`
            ]);
            meterInfoRow.font = { bold: true };
            meterInfoRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            });
    
            const titleRow = worksheet.addRow(['HOURLY Level REPORT']);
            titleRow.font = { bold: true, size: 16 };
            titleRow.alignment = { horizontal: 'center' };
            worksheet.mergeCells(titleRow.number, 1, titleRow.number, 3);
            titleRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1E90FF' },
                };
            });
    
            const headers = ['Date', 'Time Interval', 'Water Level'];
            const headerRow = worksheet.addRow(headers);
            headerRow.font = { bold: true };
            headerRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFA500' },
                };
                cell.alignment = { horizontal: 'center' };
            });
    
            hourlyData.forEach((row, index) => {
                const dataRow = worksheet.addRow([
                    row.date,
                    row.timeInterval,
                    row.waterLevel,
                ]);
    
                dataRow.eachCell(cell => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                    };
                    cell.alignment = { horizontal: 'center' };
                });
            });
    
            const totalRow = worksheet.addRow([
                'TOTAL', '', totalWaterlevel
            ]);
            totalRow.font = { bold: true };
            totalRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFEB3B' },
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
    
            worksheet.columns = [
                { width: 20 },
                { width: 20 },
                { width: 20 }
            ];
    
            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            });
        };
    
        const handleDailyExportToExcel = async () => {
            if (!fromDate || !toDate || !meterId) {
                alert("Please select both date range and ensure meter ID is available");
                return;
            }
    
            if (!dailyreportData || dailyreportData.length === 0) {
                alert("No data available to export.");
                return;
            }
    
            const fromDateTime = new Date(fromDate);
            const toDateTime = new Date(toDate);
    
            const formattedFromDate = fromDateTime.toISOString().split('T')[0];
            const formattedFromTime = fromDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');
    
            const formattedToDate = toDateTime.toISOString().split('T')[0];
            const formattedToTime = toDateTime.toTimeString().split(' ')[0].replace(/:/g, '-');
    
            const fileName = `Daily_Report_${formattedFromDate}_${formattedFromTime}_to_${formattedToDate}_${formattedToTime}.xlsx`;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Daily Report');
    
            for (let rowNum = 1; rowNum <= 3; rowNum++) {
                const row = worksheet.getRow(rowNum);
                for (let i = 1; i <= 3; i++) {
                    row.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFDDDDDD' },
                    };
                }
            }
    
            try {
                const logoBase64 = await getBase64FromImageUrl('/brad.png');
                const logoId = workbook.addImage({
                    base64: logoBase64,
                    extension: 'png'
                });
    
                const centerCol = Math.floor(3 / 2) - 1;
    
                worksheet.addImage(logoId, {
                    tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                    br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                    editAs: 'oneCell'
                });
    
                worksheet.getRow(1).height = 30;
                worksheet.getRow(2).height = 30;
                worksheet.getRow(3).height = 30;
            } catch (error) {
                console.error('Error adding logo:', error);
            }
    
            worksheet.getColumn(1).width = 20;
            worksheet.getColumn(2).width = 20;
            worksheet.getColumn(3).width = 25;
            worksheet.getColumn(4).width = 20;
            worksheet.getColumn(5).width = 20;
    
            const dateRow = worksheet.addRow([`From Date: ${moment(fromDate).format("YYYY-MM-DD HH:mm")}, To Date: ${moment(toDate).format("YYYY-MM-DD HH:mm")}`]);
            worksheet.mergeCells(dateRow.number, 1, dateRow.number, 3);
            dateRow.font = { bold: true, size: 14 };
            dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
            dateRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFD9EAD3' },
                };
            });
    
            const branchRow = worksheet.addRow(['Site: Coimbatore', '', `Meter ID: ${meterId}`]);
            branchRow.font = { bold: true, size: 12 };
            branchRow.getCell(1).alignment = { horizontal: 'left' };
            branchRow.getCell(3).alignment = { horizontal: 'center' };
            branchRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            });
    
            const titleRow = worksheet.addRow(['Daily Report']);
            titleRow.font = { bold: true, size: 16 };
            titleRow.alignment = { horizontal: 'center' };
            worksheet.mergeCells(titleRow.number, 1, titleRow.number, 3);
            titleRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1E90FF' },
                };
            });
    
            const headers = ['Date', 'Time Range', 'Water Level'];
            const headerRow = worksheet.addRow(headers);
            headerRow.font = { bold: true };
            headerRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFA500' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
    
            dailyreportData.forEach((row, index) => {
                const dataRow = worksheet.addRow([
                    formatDateForDisplay(row.date),
                    row.timeRange,
                    row.waterLevel,
                ]);
    
                dataRow.eachCell(cell => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                    };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                });
            });
    
            const totalRow = worksheet.addRow(['','TOTAL', totalDailyLiters]);
            totalRow.font = { bold: true };
            totalRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFEB3B' },
                };
                cell.alignment = { horizontal: 'right' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
    
            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            });
        };
    
        const handleMonthlyExportToExcel = async () => {
            if (!monthlyfromDate || !monthlytoDate || !meterId) {
                alert("Please select both date range and ensure meter ID is available");
                return;
            }
    
            if (!monthData || monthData.length === 0) {
                alert("No data available to export.");
                return;
            }
    
            const fromMonthYear = `${monthlyfromDate.getFullYear()}-${(monthlyfromDate.getMonth() + 1).toString().padStart(2, '0')}`;
            const toMonthYear = `${monthlytoDate.getFullYear()}-${(monthlytoDate.getMonth() + 1).toString().padStart(2, '0')}`;
    
            const fileName = `Monthly_Report_${fromMonthYear}_to_${toMonthYear}.xlsx`;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Monthly Report');
    
            for (let rowNum = 1; rowNum <= 3; rowNum++) {
                const row = worksheet.getRow(rowNum);
                for (let i = 1; i <= 3; i++) {
                    row.getCell(i).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFDDDDDD' },
                    };
                }
            }
    
            try {
                const logoBase64 = await getBase64FromImageUrl('/brad.png');
                const logoId = workbook.addImage({
                    base64: logoBase64,
                    extension: 'png'
                });
    
                const centerCol = Math.floor(3 / 2) - 1;
    
                worksheet.addImage(logoId, {
                    tl: { col: centerCol + 1, row: 0, colOff: 0, rowOff: 0 },
                    br: { col: centerCol + 2, row: 3, colOff: 0, rowOff: 0 },
                    editAs: 'oneCell'
                });
    
                worksheet.getRow(1).height = 30;
                worksheet.getRow(2).height = 30;
                worksheet.getRow(3).height = 30;
            } catch (error) {
                console.error('Error adding logo:', error);
            }
    
            worksheet.getColumn(1).width = 10;
            worksheet.getColumn(2).width = 20;
            worksheet.getColumn(3).width = 25;
            worksheet.getColumn(4).width = 20;
            worksheet.getColumn(5).width = 20;
    
            const dateRangeText = `From Month: ${monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })} to ${monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}`;
            const dateRow = worksheet.addRow([dateRangeText]);
            worksheet.mergeCells(dateRow.number, 1, dateRow.number, 3);
            dateRow.font = { bold: true, size: 14 };
            dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
            dateRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFD9EAD3' },
                };
            });
    
            const branchRow = worksheet.addRow(['Site: Coimbatore','',`Meter ID: ${meterId}`]);
            branchRow.font = { bold: true, size: 12 };
            branchRow.getCell(1).alignment = { horizontal: 'left' };
            branchRow.getCell(3).alignment = { horizontal: 'center' };
            branchRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFDDDDDD' },
                };
            });
    
            const titleRow = worksheet.addRow(['Monthly Report']);
            titleRow.font = { bold: true, size: 16 };
            titleRow.alignment = { horizontal: 'center' };
            worksheet.mergeCells(titleRow.number, 1, titleRow.number, 3);
            titleRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FF1E90FF' },
                };
            });
    
            const headers = ['S.No', 'Month', 'Water Level'];
            const headerRow = worksheet.addRow(headers);
            headerRow.font = { bold: true };
            headerRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFA500' },
                };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
    
            monthData.forEach((row, index) => {
                const dataRow = worksheet.addRow([
                    row.id,
                    row.month,
                    row.totalLevel.toFixed(2)
                ]);
    
                dataRow.eachCell(cell => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: index % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF' },
                    };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                });
            });
    
            const totalRow = worksheet.addRow(['','TOTAL', reportData?.total_level_all_months?.toFixed(2) || '0.00']);
            totalRow.font = { bold: true };
            totalRow.eachCell(cell => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFFEB3B' },
                };
                cell.alignment = { horizontal: 'right' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
    
            workbook.xlsx.writeBuffer().then((buffer) => {
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(url);
            });
        };
    
    const getBase64FromImageUrl = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };


    return (
        <div className="dashboard-container">
            <Header title="BRADKEN WATER LEVEL MANAGEMENT DASHBOARD" />
            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1000px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <h3 className="dashboard-subtitle">
                    <>
                        <span
                            onClick={() => navigate(-1)}
                            title={`Navigate to Main`}
                            style={{ color: '#007bff', cursor: 'pointer' }}
                        >
                            Level Meter
                        </span>
                        {' / '}
                    </>
                    <span>{meterId}</span>
                </h3>
                <div className="widgets-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' }}>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Today's</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', paddingBottom: '15px' }}>Water Level</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                        {waterLevelData?.today?.water_level ?? 'N/A'} m
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #4caf50, #2b9e36)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Yesterday</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Water Level</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                        {waterLevelData?.yesterday?.water_level ?? 'N/A'} m
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #2196f3, #0b7dda)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Current Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Total Level</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                        {waterLevelData?.current_month?.water_level ?? 'N/A'} m
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="widget-container" style={{ width: '100%' }}>
                        <div className="widget" style={{ padding: '10px', border: '1px solid #ccc', background: 'linear-gradient(145deg, #ed76fd, #e53afd)', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}>
                            <h3>Last Month</h3>
                            <div style={{ display: 'table', width: '100%' }}>
                                <div style={{ display: 'table-row' }}>
                                    <p style={{ display: 'table-cell', paddingRight: '10px', textAlign: 'left', color: '#ffffff', paddingBottom: '15px' }}>Total Level</p>
                                    <p style={{ display: 'table-cell', textAlign: 'center' }}>:</p>
                                    <p style={{ display: 'table-cell', paddingLeft: '10px', textAlign: 'right' }}>
                                        {waterLevelData?.last_month?.water_level ?? 'N/A'} m
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="extra-details-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: '20px',
                    }}
                >
                    <div
                        className="container-1"
                        style={{
                            flex: 1,
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f9f9',
                        }}
                    >
                        <h4><strong>Details</strong></h4>
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                marginTop: '20px',
                                fontFamily: "'Roboto', sans-serif",
                                backgroundColor: '#fff',
                                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '10px',
                                overflow: 'hidden',
                            }}
                        >
                            <tbody>
                                {renderMeterDetails()}
                                <tr>
                                    <td colSpan="2" style={{
                                        padding: '15px',
                                        backgroundColor: '#f0f8ff',
                                        textAlign: 'center',
                                        fontWeight: 'bold',
                                        color: '#333',
                                        fontSize: '14px',
                                        borderTop: '1px solid #ddd',
                                    }}>
                                        <div>
                                            Current Level:
                                            <span style={{ fontWeight: 'normal', marginLeft: '5px' }}>
                                                {waterData?.latest_hourly_reading?.water_level !== undefined
                                                    ? `${waterData.latest_hourly_reading.water_level} m`
                                                    : 'No data available'}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="container-2"
                        style={{
                            flex: 1,
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f9f9',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Level Direction</h4>
                        <LevelTank
                            level={waterData?.latest_hourly_reading?.water_level || 0}
                            maxLevel={100}
                        />
                        <p style={{ textAlign: 'center', marginTop: '10px', fontWeight: 'bold' }}>
                            {waterData?.latest_hourly_reading?.water_level !== undefined
                                ? `${waterData.latest_hourly_reading.water_level}m (${Math.round((waterData.latest_hourly_reading.water_level / 100) * 100)}%)`
                                : 'No data available'}
                        </p>
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f0f3',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Hourly Chart</h4>
                        <div style={{ marginBottom: "20px" }}>
                            <label
                                htmlFor="date-picker"
                                style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginLeft: '40px',
                                    fontSize: "14px",
                                }}
                            >
                                Date:
                            </label>
                            <DatePicker
                                id="date-picker"
                                selected={dateselectedDate}
                                onChange={(date) => handleNewDateChange(date)}
                                dateFormat="yyyy/MM/dd"
                                customInput={
                                    <input
                                        style={{
                                            fontSize: "12px",
                                            width: '60%',
                                            padding: '5px',
                                            borderRadius: '5px',
                                            marginLeft: '-30px'
                                        }}
                                    />
                                }
                            />
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    background: '#f9f0f3',
                                    toolbar: {
                                        tools: { download: false },
                                    },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#1a27db'],
                                dataLabels: {
                                    enabled: false,
                                },
                                xaxis: {
                                    categories: chartData.time_intervals,
                                    title: {
                                        text: chartData.x_axis_label,
                                    },
                                    labels: {
                                        rotate: -45,
                                        style: {
                                            fontSize: '10px'
                                        }
                                    }
                                },
                                yaxis: {
                                    title: {
                                        text: chartData.y_axis_label,
                                    },
                                    labels: {
                                        formatter: (value) => {
                                            return new Intl.NumberFormat('en-US').format(value);
                                        },
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: (value) => {
                                            return `${new Intl.NumberFormat('en-US').format(value)} meters`;
                                        },
                                    },
                                },
                                legend: {
                                    position: 'top',
                                    horizontalAlign: 'center',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                            }}
                            series={chartData.bars.map(bar => ({
                                name: bar.name,
                                data: bar.data,
                            }))}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div
                    className="charts-container"
                    style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}
                >
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#fbe9f6',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Day's Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Month:
                            </label>
                            <select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                style={{
                                    padding: "5px",
                                    marginRight: "20px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {monthNames.map((month, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {month}
                                    </option>
                                ))}
                            </select>

                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedYear}
                                onChange={handleYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    background: '#fbe9f6',
                                    toolbar: { tools: { download: false } },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#ff47f0'],
                                dataLabels: { enabled: false },
                                xaxis: {
                                    categories: dailyData.categories,
                                    title: { text: dailyData.xAxisLabel },
                                },
                                yaxis: {
                                    title: { text: dailyData.yAxisLabel },
                                    labels: {
                                        formatter: (value) => new Intl.NumberFormat('en-US').format(value),
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: (value) => `${value.toFixed(2)} meters`,
                                    },
                                },
                                legend: { position: 'top' },
                            }}
                            series={[{
                                name: 'Water Level',
                                data: dailyData.levels
                            }]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="charts-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div
                        className="container-4"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f0fbff',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        <h4>Monthly Consumption</h4>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: "30px",
                            }}
                        >
                            <label
                                style={{
                                    fontSize: "14px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Year:
                            </label>
                            <select
                                value={selectedNewYear}
                                onChange={handleNewYearChange}
                                style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                }}
                            >
                                {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <Chart
                            options={{
                                chart: {
                                    type: 'bar',
                                    height: 350,
                                    background: '#f0fbff',
                                    toolbar: { tools: { download: false } },
                                },
                                plotOptions: {
                                    bar: {
                                        horizontal: false,
                                        columnWidth: '50%',
                                        endingShape: 'rounded',
                                    },
                                },
                                colors: ['#1a27db'],
                                dataLabels: { enabled: false },
                                xaxis: {
                                    categories: monthsData.categories,
                                    title: { text: monthsData.xAxisLabel },
                                },
                                yaxis: {
                                    title: { text: monthsData.yAxisLabel },
                                    labels: {
                                        formatter: (value) => new Intl.NumberFormat('en-US').format(value),
                                    },
                                },
                                tooltip: {
                                    y: {
                                        formatter: (value) => `${value.toFixed(2)} meters`,
                                    },
                                },
                            }}
                            series={[{
                                name: 'Water Level',
                                data: monthsData.levels
                            }]}
                            type="bar"
                            height={350}
                            width={950}
                        />
                    </div>
                </div>
                <div className="dashboard">
                    <div className="main-container">
                        <h4>Reports</h4>
                        <div className="nav-bar">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={activeTab === tab ? "active" : ""}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        {activeTab === "Hourly" && (
                            <div className="hourly-report">
                                <div className="card controls-card">
                                    <Datetime
                                        value={hourlyfromdate ? new Date(hourlyfromdate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                setHourlyfromdate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select From Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />

                                    <Datetime
                                        value={hourlytodate ? new Date(hourlytodate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                if (momentObj.hours() === 0 && momentObj.minutes() === 0) {
                                                    momentObj.set({
                                                        hour: 23,
                                                        minute: 59
                                                    });
                                                }
                                                setHourlytodate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select To Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />
                                    <button onClick={handleGetHourlyReport}>Get Report</button>
                                    <button onClick={() => handleHourlyExportToExcel('Hourly_Report.xlsx')}>
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {hourlyloading ? (
                                    <span className="spinner" />
                                ) : (
                                    <div className="table-container">
                                        <h4 className="table-title">
                                            Hourly Log View from {hourlyfromdate ? moment(hourlyfromdate).format("YYYY-MM-DD HH:mm") : "Selected from Date"}
                                            to {hourlytodate ? moment(hourlytodate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                        </h4>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Hour</th>
                                                    <th>Water Level</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {hourlyData.length > 0 ? (
                                                    currentRows.map((row, index) => (
                                                        <tr key={row.id}>
                                                            <td>{formatDateForDisplay(row.date)}</td>
                                                            <td>{row.timeInterval}</td>
                                                            <td>{row.waterLevel}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="2" style={{ textAlign: "right" }}>TOTAL</td>
                                                    <td>{totalWaterlevel}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}

                                {hourlyData.length > 0 && (
                                    <div className="pagination-controls">
                                        <button
                                            disabled={currenthourlyPage === 1}
                                            onClick={() => handlehourlyPageChange(currenthourlyPage - 1)}
                                        >
                                            Previous
                                        </button>
                                        <span> {currenthourlyPage} of {totalhourlyPages}</span>
                                        <button
                                            disabled={currenthourlyPage === totalhourlyPages}
                                            onClick={() => handlehourlyPageChange(currenthourlyPage + 1)}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}
                        {activeTab === "Daily" && (
                            <div className="daily-report">
                                <div className="card controls-card">
                                    <Datetime
                                        value={fromDate ? new Date(fromDate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                setFromDate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select From Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />
                                    <Datetime
                                        value={toDate ? new Date(toDate) : null}
                                        onChange={(momentObj) => {
                                            if (momentObj.isValid()) {
                                                if (momentObj.hours() === 0 && momentObj.minutes() === 0) {
                                                    momentObj.set({
                                                        hour: 23,
                                                        minute: 59
                                                    });
                                                }
                                                setToDate(momentObj.format("YYYY-MM-DDTHH:mm"));
                                            }
                                        }}
                                        inputProps={{
                                            placeholder: "Select To Date Time",
                                            style: { borderRadius: "10px", border: "1px solid #007bff", padding: "10px", width: "80%" }
                                        }}
                                        dateFormat="YYYY-MM-DD"
                                        timeFormat="HH:mm"
                                        closeOnSelect={false}
                                    />
                                    <button onClick={handleGetDailyReport}>Get Report</button>
                                    <button onClick={() => {
                                        const fileName = `Daily_Report_${fromDate}_to_${toDate}.xlsx`;
                                        handleDailyExportToExcel(dailyreportData, fileName);
                                    }}
                                    >
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {dailyloading ? (
                                    <span className="spinner" />
                                ) : (
                                    <div className="table-container">
                                        <h4 className="table-title">
                                            Daily Log View from {fromDate ? moment(fromDate).format("YYYY-MM-DD HH:mm") : "Selected from Date"}
                                            to {toDate ? moment(toDate).format("YYYY-MM-DD HH:mm") : "Selected to date"}
                                        </h4>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>time</th>
                                                    <th>Water Level</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentDailyRows.length > 0 ? (
                                                    currentDailyRows.map((row) => (
                                                        <tr key={row.id}>
                                                            <td>{formatDateForDisplay(row.date)}</td>
                                                            <td>{row.timeRange}</td>
                                                            <td>{row.waterLevel}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="2" style={{ textAlign: "right" }}>TOTAL</td>
                                                    <td>{totalDailyLiters}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
                                    <button
                                        disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                                        onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                        {activeTab === "Monthly" && (
                            <div className="Monthly-Report">
                                <div className="card controls-card">
                                    <DatePicker
                                        selected={monthlyfromDate}
                                        onChange={handleMonthlyFromMonthChange}
                                        dateFormat="yyyy-MM"
                                        showMonthYearPicker
                                        placeholderText="Select From Month"
                                        className="custom-date-picker"
                                    />

                                    <DatePicker
                                        selected={monthlytoDate}
                                        onChange={handleMonthlyToMonthChange}
                                        dateFormat="yyyy-MM"
                                        showMonthYearPicker
                                        placeholderText="Select To Month"
                                        className="custom-date-picker"
                                    />
                                    <button onClick={fetchMonthlyReport}>Get Report</button>
                                    <button onClick={handleMonthlyExportToExcel}>
                                        <i className="excel-icon">📊</i> Excel
                                    </button>
                                </div>
                                {monthlyloading ? (
                                    <div>
                                        <span className="spinner"></span>
                                    </div>
                                ) : (
                                    <div className="table-container">
                                        <h4 className="table-title">Monthly Report from {monthlyfromDate ? monthlyfromDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected from Month"} to {monthlytoDate ? monthlytoDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long' }) : "Selected to Month"}</h4>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Month</th>
                                                    <th>Water Level</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentMonthlyRows.length > 0 ? (
                                                    currentMonthlyRows.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.id}</td>
                                                            <td>{item.month}</td>
                                                            <td>{item.totalLevel.toFixed(2)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="3" style={{ textAlign: "center" }}>
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="2" style={{ textAlign: "right" }}>TOTAL</td>
                                                    <td>{reportData?.total_level_all_months?.toFixed(2) || '0'}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                                <div className="pagination-controls">
                                    <button
                                        disabled={currentmonthlyreportPage === 1 || currentMonthlyRows.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage - 1)}
                                    >
                                        Previous
                                    </button>
                                    <span>  {currentmonthlyreportPage}   of   {totalmonthlyPages}  </span>
                                    <button
                                        disabled={currentmonthlyreportPage === totalmonthlyPages || currentMonthlyRows.length === 0}
                                        onClick={() => handlemonthlyPageChange(currentmonthlyreportPage + 1)}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Levelsub;